import { NullableString } from '@core/types/nullable'

export type GrandType = 'credentials' | 'refresh_token'

export class TokenRequest {
	grant_type?: GrandType
	credentials?: Credentials
	token?: NullableString

	static withCredentials(credentials: Credentials): TokenRequest {
		const tokenRequest = new TokenRequest()
		tokenRequest.grant_type = 'credentials'
		tokenRequest.credentials = credentials
		return tokenRequest
	}

	static withRefreshToken(refreshToken: string): TokenRequest {
		const tokenRequest = new TokenRequest()
		tokenRequest.grant_type = 'refresh_token'
		tokenRequest.token = refreshToken
		return tokenRequest
	}
}

export interface Credentials {
	email: string
	password: string
}

export interface TokenResponse {
	token: string
	refresh_token: string
}
